export const validateCPFCNPJ = (cpfCnpj) => {

  if (cpfCnpj.length > 14) {
    const regex = /^(\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})$/;
    return regex.test(cpfCnpj);
  } else {
    const regex = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2})$/;
    return regex.test(cpfCnpj);
  }
};

export const formatCPFCNPJ = (cpfCnpj) => {
  let str = cpfCnpj?.toString().replace(/\D/g, '') // Remove qualquer caractere não numérico

  if (str.length > 11) {
    return str
      .replace(/(\d{2})(\d)/, '$1.$2') // Adiciona o primeiro ponto
      .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
      .replace(/(\d{3})(\d)/, '$1/$2') // Adiciona a barra
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2'); // Adiciona o traço
  } else {
    return str
      .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o primeiro ponto
      .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2'); // Adiciona o traço
  }
};